import {
    LOGIN_USER,
    LOGIN_USER_SUCCESS,
    LOGIN_USER_ERROR,
    REGISTER_USER,
    REGISTER_USER_SUCCESS,
    REGISTER_USER_ERROR,
    LOGOUT_USER,
    CHANGE_PASSWORD,
    CHANGE_PASSWORD_SUCCESS,
    CHANGE_PASSWORD_ERROR,
    RESET_PASSWORD,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_ERROR
} from '../actions';

const INIT_STATE = {
    user: localStorage.getItem('user_id'),
    firstName: localStorage.getItem('firstName'),
    secondName: localStorage.getItem('secondName'),
    roles: JSON.parse(localStorage.getItem('roles') || '[]'),
    forgotUserMail: '',
    newPassword: '',
    confirmPassword: '',
    token: '',
    changePassword: '',
    loading: false,
    error: ''
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case LOGIN_USER:
            return { ...state, loading: true, error: '' };
        case LOGIN_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                user: action.payload.uid,
                firstName: action.payload.firstName,
                secondName: action.payload.secondName,
                roles: action.payload.roles,
                error: ''
            };
        case LOGIN_USER_ERROR:
            return { ...state, loading: false, user: '', error: action.payload.message };
        case CHANGE_PASSWORD:
            return { ...state, loading: true, error: ''};
        case CHANGE_PASSWORD_SUCCESS:
            return { ...state, loading: true, error: ''};
        case CHANGE_PASSWORD_ERROR:
            return { ...state, loading: true, error: ''};
        case RESET_PASSWORD:
            return { ...state, loading: true, error: '' };
        case RESET_PASSWORD_SUCCESS:
            return { ...state, loading: false, newPassword: action.payload, resetPasswordCode: '', error: '' };
        case RESET_PASSWORD_ERROR:
            return { ...state, loading: false, newPassword: '', resetPasswordCode: '', error: action.payload.message };
        case REGISTER_USER:
            return { ...state, loading: true, error: '' };
        case REGISTER_USER_SUCCESS:
            return { ...state, loading: false, user: action.payload.uid, error: '' };
        case REGISTER_USER_ERROR:
            return { ...state, loading: false, user: '', error: action.payload.message };
        case LOGOUT_USER:
            return { ...state, user: null, error: '' };
        default: return { ...state };
    }
}
